// FRONT-point classification: which sector type is directly under the faller.
// The faller sits at the ellipse's nearest point — screen angle π/2 (bottom).
// So the local angle at FRONT is (π/2 − towerAngle); we find the sector whose
// (possibly oscillating) range contains it. Pure: no side effects (ТЗ 5.2).
import { Ring, SectorType } from './types';
import { sectorRange } from './tower';

const TWO_PI = Math.PI * 2;
const FRONT = Math.PI / 2;

function norm(a: number): number {
  a %= TWO_PI;
  return a < 0 ? a + TWO_PI : a;
}

// Is angle α within [a0,a1) on the circle (handles wraparound + offset ranges)?
function inRange(alpha: number, a0: number, a1: number): boolean {
  const a = norm(alpha), lo = norm(a0), hi = norm(a1);
  return lo <= hi ? (a >= lo && a < hi) : (a >= lo || a < hi);
}

/**
 * Type of the sector currently under the FRONT point (or 'gap' if none covers it).
 * When an oscillating sector overlaps a neighbour, drawRingHalf (renderer.ts) fills
 * sectors in index order, so the higher-index sector paints over the lower one and
 * is what the player actually sees — keep scanning and take the LAST match, not the
 * first, so collision agrees with the visible pixel.
 */
export function frontType(ring: Ring, towerAngle: number, t: number): SectorType {
  const alpha = norm(FRONT - towerAngle);
  let result: SectorType = 'gap';
  for (const s of ring.sectors) {
    if (s.type === 'gap') continue;            // gaps are absence — skip; default below
    const [a0, a1] = sectorRange(s, t);
    if (inRange(alpha, a0, a1)) result = s.type;
  }
  return result;
}
